import { EntityPagedRequestParameters } from '@bndes/bndes-ux4/bndes-angular-utils'

export class Paginacao<T> {
  parametros: EntityPagedRequestParameters;
  tamanhosPagina: number[];
  itens: T[];
  itensPagina: T[];

  constructor(tamanhosDePagina: number[], itens: T[] = []) {
    this.parametros = { page: 1, pageSize: tamanhosDePagina[0] };
    this.tamanhosPagina = tamanhosDePagina;
    this.atualizarItens(itens);
  }

  public atualizarItens(itens: T[]): void {
    this.itens = itens;
    this.contornarBugDePaginaVazia();
    this.atualizar();
  }

  atualizar(): void {
    const posInicial = (this.parametros.page - 1) * this.parametros.pageSize;
    const posFinal = Math.min(posInicial + this.parametros.pageSize, this.itens.length);
    this.itensPagina = this.itens.slice(posInicial, posFinal);
  }

  aoMudar(parametros: EntityPagedRequestParameters): void {
    this.parametros = parametros;
    this.contornarBugDePaginaVazia();
    this.atualizar();
  }

  private contornarBugDePaginaVazia(): void {
    const ultimaPagina = Math.ceil(this.itens.length / this.parametros.pageSize);
    if (ultimaPagina > 0 && this.parametros.page > ultimaPagina) {
      this.parametros.page = ultimaPagina;
    }
  }
}
